/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 09.09.17.
 */

import React from "react";
import PropTypes from "prop-types";
import TextareaAutosize from "react-autosize-textarea";

/**
 * Replacement of standard textarea widget.
 * Implements autoresize.
 */
class TextareaWidget extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        options: PropTypes.shape({
            rows: PropTypes.number,
        }),
        value: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        autofocus: PropTypes.bool,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func
    };

    static defaultProps = {
        autofocus: false,
        options: {}
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            id,
            options,
            placeholder,
            value,
            required,
            disabled,
            readonly,
            autofocus,
            onChange,
            onBlur,
            onFocus,
        } = this.props;
        const _onChange = ({ target: { value } }) => {
            return onChange(value === "" ? options.emptyValue : value);
        };
        return (
            <TextareaAutosize
                id={id}
                className="form-control"
                value={typeof value === "undefined" ? "" : value}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                readOnly={readonly}
                autoFocus={autofocus}
                rows={options.rows ? options.rows : 2}
                onBlur={onBlur && (event => onBlur(id, event.target.value))}
                onFocus={onFocus && (event => onFocus(id, event.target.value))}
                onChange={_onChange}
            />
        );
    }
}

export default TextareaWidget;
